<template>
  <div>
    <v-data-table
      show-expand
      :headers="headers"
      :items="produtos.content"
      :expanded.sync="expanded"
      class="elevation-1 mt-5 pt-3 rounded-card"
      :loading="loading"
      :server-items-length="produtos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum produto encontrado"
      loading-text="Carregando produtos..."
      :options="optionsList"
    >
      <template v-slot:item.codigoFornecedor="{ item }">
        {{ item.codigoFornecedor | naoInformado }}
      </template>
      <template v-slot:item.grupoProduto.descricao="{ item }">
        {{ labelGrupo(item) }}
      </template>
      <template v-slot:item.tipoProduto="{ item }">
        <px-show-tipo-produto :tipo-produto="item.tipoProduto"/>
      </template>
      <template v-slot:item.ncm="{ item }">
        {{ item.ncm | naoInformado }}
      </template>
      <template v-slot:item.options="{ item }">
        <div class="d-flex justify-end">
          <px-show-ativo-produto :ativo="item.ativo"/>
          <px-produtos-list-menu  v-if="hasRoleCadastroProduto"
                                  @remove="onRemove(item)"
                                  :item="item"/>
        </div>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length" class="grey lighten-4 expanded-item">
          <v-row class="mt-2">
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Especificação</span>
              <div>
                <px-show-large-text :large-text="item.especificacao"/>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Observação Interna</span>
              <div>
                <px-show-large-text :large-text="item.observacaoInterna"/>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Observação Externa</span>
              <div>
                <px-show-large-text :large-text="item.observacaoExterna"/>
              </div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProdutosListMenu from './ProdutosListMenu.vue';

export default {
  props: {
    produtos: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código interno',
          value: 'codigo',
        },
        {
          text: 'Código fornecedor',
          value: 'codigoFornecedor',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Tipo',
          value: 'tipoProduto',
        },
        {
          text: 'UM',
          value: 'unidadeMedida.descricao',
        },
        {
          text: 'Categoria',
          value: 'grupoProduto.descricao',
        },
        {
          text: 'NCM',
          value: 'ncm',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleCadastroProduto']),
    labelGrupo() {
      return item => (item.grupoProduto ? item.grupoProduto.descricao : '-');
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    onRemove(item) {
      this.$emit('remove', item);
    },
  },
  components: {
    pxProdutosListMenu: ProdutosListMenu,
  },
};
</script>
